import { render } from "./RiskApplicationBox.vue?vue&type=template&id=69090d18"
import script from "./RiskApplicationBox.vue?vue&type=script&lang=js"
export * from "./RiskApplicationBox.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./RiskApplicationBox.vue?vue&type=style&index=0&id=69090d18&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__